import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { SessionService } from "../../common/services/session.service";

import { UserService } from "../userService/api/user.service";

@Component({
  selector: 'app-permission-mgmt-list',
  templateUrl: './permission-mgmt-list.component.html',
  styleUrls: ['./permission-mgmt-list.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class PermissionMgmtListComponent implements OnInit {
  userData: any;
  userCount: number = 0;
  officeData: any;
  constructor(
    private userService: UserService,
    private router: Router,
    private toast: MessageService,
    private sessionService: SessionService,
    private confirmation: ConfirmationService
  ) {}

  getUserList() {
    this.userService.getUserData().subscribe((data) => {
      this.setUserList(data);
    });
  }

  setUserList(data: any) {
    let tmpUsers = [];
    data.filter((obj) => {
      obj.role != "KARYA_KARTA" && obj.role != "OFFICE_ADMIN"
        ? tmpUsers.push(obj)
        : "";
    });
    this.userData = tmpUsers;
  }

  editUser(user) {
    let userId = user ? user.id : null;
    this.router.navigate(["/user/edit/" + userId]);
  }

  deleteUser(userId) {
    this.confirmation.confirm({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {
        this.userService.deleteUserData(userId).subscribe((res) => {
          this.getUserList();
          this.toast.add({
            severity: "success",
            summary: "Confirmed",
            detail: "Record deleted",
          });
        });
      },
      reject: () => {
        this.toast.add({
          severity: "error",
          summary: "Rejected",
          detail: "You have rejected",
        });
      },
    });
  }

  ngOnInit() {
    this.getUserList();
    this.officeData = this.sessionService.getOffice();
  }
}
